import type { SkillSummary } from '@/hooks/use-profile'
import { formatSkillTenureFromMonths } from '@/lib/format-skill-tenure'

/** Positive recency only — omit "Not recent" and "Undated" from peek surfaces. */
export function formatPositiveRecencyDisplay(recencyLabel: string): string | null {
  if (recencyLabel === 'Current') return 'Current role'
  if (recencyLabel === 'Recent') return 'Recent'
  return null
}

/** Tenure / proof line for top-skill tooltips (excludes proficiency). */
export function buildTopSkillSubtitleParts(summary: SkillSummary): string[] {
  const parts: string[] = []
  const { experiences, education, certifications } = summary.evidence_counts
  const hasWorkEvidence = experiences > 0

  const recency = formatPositiveRecencyDisplay(summary.recency_label)
  if (recency) {
    parts.push(recency)
  }

  if (hasWorkEvidence) {
    if (summary.experience_months > 0) {
      parts.push(formatSkillTenureFromMonths(summary.experience_months))
    }
    return parts
  }

  if (education > 0 && certifications === 0) {
    parts.push('Proved via education')
  } else if (certifications > 0 && education === 0) {
    parts.push('Proved via certification')
  } else if (education > 0 || certifications > 0) {
    parts.push('Proved via profile')
  }

  return parts
}

export function formatTopSkillSubtitleLine(summary: SkillSummary): string {
  return buildTopSkillSubtitleParts(summary).join(' · ')
}

/** Proficiency + subtitle for aria labels. */
export function formatTopSkillAriaMeta(summary: SkillSummary): string {
  return [summary.proficiency_label, ...buildTopSkillSubtitleParts(summary)].join(', ')
}
